import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import { motion } from 'framer-motion';
import styled from 'styled-components';
import FooterSharedStyles from '../Shared/FooterShared.styles';
const Container = styled(motion.section) ``;
const Title = styled(FooterSharedStyles.Title) ``;
const TitleIcon = styled(FooterSharedStyles.TitleIcon) ``;
const ContentWrapper = styled(motion.div) `
  overflow: hidden;

  @media ${from(Device.Tablet)} {
    height: auto !important;
  }
`;
const Content = styled.div `
  display: block;
  margin: 0 0 24px;
  ${fonts.gillSans.light};
  font-size: 20px;
  line-height: 30px;
  text-align: center;

  @media ${from(Device.Tablet)} {
    height: auto !important;
    text-align: left;
  }

  @media ${from(Device.TabletLarge)} {
    font-size: 16px;
    line-height: 28px;
  }
`;
export default {
    Container,
    Content,
    ContentWrapper,
    Title,
    TitleIcon,
};
